import type { ReactNode } from "react";

import { Spinner, Text } from "@/components/customComponents";

import useDelayedFlag from "./useDelayedFlag";

type GalleryTitleProps = {
  title: ReactNode;
  isLoading: boolean;
  delayMs: number;
  testId: string;
};

const GalleryTitle = ({ title, isLoading, delayMs, testId }: GalleryTitleProps) => {
  const isRequestSlow = useDelayedFlag(isLoading, delayMs);

  return (
    <div data-testid={testId} className="flex items-center gap-3 px-4 max-mob:px-2">
      <Text h1 className="m-0" variant="xxl">
        {title}
      </Text>
      {/* Hidden from assistive tech: the grid's own status line already announces the load. */}
      {isRequestSlow ? (
        <span aria-hidden="true" data-testid={`${testId}-Spinner`} className="flex">
          <Spinner />
        </span>
      ) : null}
    </div>
  );
};

export default GalleryTitle;
